// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jEdBc","title":"Header_title__1TSXn","left":"Header_left__3HR1I","clinicName":"Header_clinicName__dacTT"};